export enum CampaignTypeVatType {
  WithVat = 1,
  WithoutVat = 2
}

(CampaignTypeVatType as any).__typeName = 'CampaignTypeVatType';
